const ppValue = 199; // whole professional assembly
const paValue = 199; // whole protection plan cart

export { ppValue, paValue };